<template>
  <div :class="{ 'sound-icon': true, 'muted': muted }">
    {{ canPlayAudio }}
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="0 0 24 26" fill="none">
      <g id="sound-icon">
      <path id="unmuted-body" d="M2 18.5V9.5V7.5C2 7.22386 2.22386 7 2.5 7H9.32845C9.43963 7 9.54765 6.96294 9.63542 6.89468L17.693 0.627644C18.0215 0.372199 18.5 0.606246 18.5 1.02232V24.9777C18.5 25.3938 18.0215 25.6278 17.693 25.3724L9.63542 19.1053C9.54765 19.0371 9.43963 19 9.32845 19H2.5C2.22386 19 2 18.7761 2 18.5Z" fill="white"/>
      <path id="muted-body" fill-rule="evenodd" clip-rule="evenodd" d="M2.75438 7.00009H2.5C2.22386 7.00009 2 7.22395 2 7.50009V9.50009V18.5001C2 18.7762 2.22386 19.0001 2.5 19.0001H9.32845C9.43963 19.0001 9.54765 19.0372 9.63542 19.1054L17.693 25.3724C18.0215 25.6279 18.5 25.3938 18.5 24.9778V22.7457L2.75438 7.00009ZM18.5 16.2545V1.02241C18.5 0.606336 18.0215 0.372289 17.693 0.627734L9.63542 6.89477C9.54765 6.96303 9.43963 7.00009 9.32845 7.00009H9.24562L18.5 16.2545Z" fill="white" class=""/>
      <path id="muted-line" fill-rule="evenodd" clip-rule="evenodd" d="M0.436284 1.43628C0.747162 1.12541 1.2512 1.12541 1.56207 1.43628L23.5621 23.4363C23.873 23.7472 23.873 24.2512 23.5621 24.5621C23.2512 24.873 22.7472 24.873 22.4363 24.5621L0.436284 2.56207C0.125405 2.2512 0.125405 1.74716 0.436284 1.43628Z" fill="white"/>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "SoundIcon",
  props: ["muted"],
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
  }
};
</script>

<style>
.sound-icon {
  display: flex;
  height: 24px;
}

.sound-icon svg {
  height: 100%;
}

.sound-icon svg path {
  fill: #bebebe;
}

.sound-icon.muted {

}

.sound-icon #unmuted-body {
  display: block;
}

.sound-icon #muted-body,
.sound-icon #muted-line {
  display: none;
}

/* Muted */
.sound-icon.muted #unmuted-body {
  display: none;
}

.sound-icon.muted #muted-body,
.sound-icon.muted #muted-line {
  display: block;
}
</style>
